import { ref } from "valtio";

import { IS_NODE } from "@/__main__/constants.mjs";

/**
 * This function marks all nested objects as refs for valtio to completely
 * neuter reactivity. The main reason to do this is to prevent mutations
 * on objects we have persisted in the DB to reflect in any UI.
 */
export default function deepRef<O extends object>(obj: O): O | AsRef<O> {
  if (IS_NODE) return obj;

  for (const key in obj) {
    const value = obj[key];

    if (value && typeof value === "object" && !(value instanceof Date)) {
      obj[key] = deepRef(value as unknown as object) as unknown as O[Extract<
        keyof O,
        string
      >];
    }
  }

  return ref(obj);
}
